import { render } from "./MediumPostsSection.vue?vue&type=template&id=8cdc8ed0&scoped=true"
import script from "./MediumPostsSection.vue?vue&type=script&lang=js"
export * from "./MediumPostsSection.vue?vue&type=script&lang=js"

import "./MediumPostsSection.vue?vue&type=style&index=0&id=8cdc8ed0&lang=css&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdc8ed0"]])

export default __exports__